import 'vuetify/dist/vuetify.min.css';

import Bullhorn from '@components/Icons/bullhorn';
import Check from '@components/Icons/check';
import Map from '@components/Icons/map';
import SellTag from '@components/Icons/sellTag';
import ThumbUp from '@components/Icons/thumbUp';
import Tune from '@components/Icons/tune';
import Vue from 'vue';
// vuetify components used in .vue files will be imported automatically
// any used outside of .vue files (*.php) will need to be imported/exported here and will then be available globally
import Vuetify, { VApp, VBtn, VChip, VCard, VRow, VCol, VTextField, VSelect, VCardActions, VCardSubtitle, VCardText, VCardTitle, VDialog, VProgressCircular } from 'vuetify/lib';
import colors from 'vuetify/lib/util/colors';

Vue.use(Vuetify, {
  components: {
    VApp,
    VBtn,
    VChip,
    VRow,
    VCol,
    VCard,
    VTextField,
    VSelect,
    VCardActions,
    VCardSubtitle,
    VCardText,
    VCardTitle,
    VDialog,
    VProgressCircular
  }
});

const bandwangoColors = {
  green: {
    base: '#82BE00',
    lighten5: '#F2F9E5'
  },
  'blue-grey': {
    base: '#003E52'
  }
};

const vuetifyOpts = {
  theme: {
    options: {
      customProperties: true
    },
    themes: {
      light: {
        'bw-primary': bandwangoColors.green,
        'bw-secondary': bandwangoColors['blue-grey'],
        primary: '#82BA0C',
        secondary: '#3e69c9',
        info: '#4ea9e6',
        error: '#d26a5c'
      }
    }
  },
  icons: {
    values: {
      sellTag: { component: SellTag },
      map: { component: Map },
      bullhorn: { component: Bullhorn },
      tune: { component: Tune },
      thumbUp: { component: ThumbUp },
      check: { component: Check }
    }
  },
  css: {
    extract: { ignoreOrder: true }
  }
};

export default new Vuetify(vuetifyOpts);
